import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/AboutModalBox/about-modal-box';
import { Button } from '../Button';
import TimesIcon from '@patternfly/react-icons/dist/js/icons/times-icon';
export var AboutModalBoxCloseButton = function AboutModalBoxCloseButton(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$onClose = _a.onClose,
      onClose = _a$onClose === void 0 ? function () {
    return undefined;
  } : _a$onClose,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? 'Close Dialog' : _a$ariaLabel,
      props = __rest(_a, ["className", "onClose", 'aria-label']);

  return React.createElement("div", Object.assign({
    className: css(styles.aboutModalBoxClose, className)
  }, props), React.createElement(Button, {
    variant: "plain",
    onClick: onClose,
    "aria-label": ariaLabel
  }, React.createElement(TimesIcon, null)));
};